import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import api from "../../services/axios-client.js";
import { iUser, User } from "../../models/User";
import PopAddEditUser from "../../components/User/PopAddEditUser";

const Users = () => {
  const [users, setUsers] = useState<iUser[]>([]);
  const [user, setUser] = useState<iUser | null>(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get("/user");
      setUsers(response.data.users);
    } catch (error) {
      console.log(error);
    }
  };

  const updateUsersList = (user: iUser) => {
    setUsers((prevUsers) => {
      // A flag to check if the user was updated.
      let userUpdated = false;

      const updatedUsers = prevUsers.map((u) => {
        if (u.user_id === user.user_id) {
          userUpdated = true; // Set the flag to true if the user is found.
          return user;
        }
        return u;
      });

      // If the user wasn't found in the loop, add them to the end.
      if (!userUpdated) {
        return [...updatedUsers, user];
      }

      return updatedUsers;
    });

    setUser(null);
  };

  return (
    <>
      <div className="content-header pb-6 flex justify-between">
        <div className="content-header-label">Questions</div>
        <div className="content-header-actions">
          <Button
            onClick={() => {
              setUser(new User());
            }}
          >
            Add New User
          </Button>
        </div>
      </div>
      <div className="content-body">
        <table className="table-auto border w-full">
          <thead>
            <tr>
              <th className="font-bold p-2 border-b text-left w-2">No</th>
              <th className="font-bold p-2 border-b text-left">User Name</th>
              <th className="font-bold p-2 border-b text-left">Email</th>
              <th className="font-bold py-2 px-4 border-b text-left w-40">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {users.map((user: iUser, index: number) => (
              <tr key={index}>
                <td className="p-2 border-b text-left">{index + 1}</td>
                <td className="p-2 border-b text-left">{`${user.first_name} ${user.last_name}`}</td>
                <td className="p-2 border-b text-left">{user.email}</td>
                <td className="py-2 px-4 border-b text-left">
                  <Button onClick={() => setUser(user)}>Edit</Button>
                  <Button onClick={(e) => {}}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {user && (
        <PopAddEditUser
          user={user}
          setUser={setUser}
          updateUsersList={updateUsersList}
        />
      )}
    </>
  );
};

export default Users;

//
